import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError, timeout } from 'rxjs';
import { catchError } from 'rxjs/operators';


@Injectable()
export class TimeoutInterceptor implements HttpInterceptor {
 
  private readonly DEFAULT_TIMEOUT = 30000;
  
  private readonly UPLOAD_TIMEOUT = 60000;
  
  private readonly HEAVY_OPERATION_TIMEOUT = 120000;

  constructor() {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {

    const timeoutMs = this.getTimeoutForRequest(request);

    return next.handle(request).pipe(
      timeout(timeoutMs),
      catchError(error => {
        if (error.name === 'TimeoutError') {
          console.error(`Requisição expirou (${timeoutMs}ms): ${request.method} ${request.url}`);
          const timeoutErrorResponse = new HttpErrorResponse({
            error: {
              message: `Requisição expirou após ${timeoutMs / 1000} segundos. Verifique sua conexão e tente novamente.`
            },
            status: 408, 
            statusText: 'Request Timeout'
          });
          return throwError(() => timeoutErrorResponse);
        }
        return throwError(() => error);
      })
    );
  }


  private getTimeoutForRequest(request: HttpRequest<unknown>): number {
    const contentType = request.headers.get('Content-Type') || '';
    const url = request.url.toLowerCase();

  
    if (contentType.includes('multipart/form-data') || 
        url.includes('upload') || 
        url.includes('attachment')) {
      return this.UPLOAD_TIMEOUT;
    }

    if (url.includes('pdf') || 
        url.includes('report') || 
        url.includes('export') ||
        url.includes('download') ||
        url.includes('template')) {
      return this.HEAVY_OPERATION_TIMEOUT;
    }

    return this.DEFAULT_TIMEOUT;
  }
}
